import React from "react";
import DataTable from "react-data-table-component";
import { Button, Box, Text } from "@chakra-ui/react";
import { RiDeleteBinLine, RiEditLine } from "react-icons/ri";
import moment from "moment";
import "moment/locale/id";

const monthName = (number) => {
  return moment()
    .month(number - 1)
    .format("MMMM");
};
const DailyTable = ({
  data,
  handleDelete,
  handleUpdate,
  resetPaginationToggle,
  filterText,
}) => {
  const columns = [
    {
      name: "Tahun Bulan ",
      selector: (row) => monthName(row.month) + " " + row.year,
      sortable: true,
    },
    {
      name:"Minggu Ke",
      selector: (row) => row.week_number,
      sortable: true,
    },
    {
      name: "NIS",
      selector: (row) => row.nis,
      sortable: true,
    },

    {
      name: "Nama Siswa",
      selector: (row) => row.student_name,
      sortable: true,
    },

    {
      name: "Actions",
      cell: (row) => (
        <div>
          <Button colorScheme="red" mr={2} onClick={() => handleDelete(row.id)}>
            <RiDeleteBinLine />
          </Button>
          <Button colorScheme="blue" onClick={() => handleUpdate(row.id)}>
            <RiEditLine />
          </Button>
        </div>
      ),
    },
  ];

  const filteredItems = data
    ? data.filter(
        (item) =>
          item.student_name &&
          item.student_name.toLowerCase().includes(filterText.toLowerCase())
      )
    : [];

  const ExpandableRowComponent = ({ data }) => {
    return (
      <Box p={4}>
        <Text fontSize="xs">Catatan :{data.activity}</Text>
      </Box>
    );
  };

  return (
    <div className="p-2">
      <DataTable
        columns={columns}
        data={filteredItems}
        pagination
        selectableRows
        persistTableHead
        paginationResetDefaultPage={resetPaginationToggle}
        defaultSortFieldId={1}
        expandableRows
        expandableRowsComponent={ExpandableRowComponent}
      />
    </div>
  );
};

export default DailyTable;
